import { call, put, takeLatest } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import { uploadProductsFile, getFileDetails } from '@/lib/api';
import {
  uploadFileRequest,
  uploadFileSuccess,
  uploadFileFailure,
  getFileDetailsRequest,
  getFileDetailsSuccess,
  getFileDetailsFailure,
} from '../slices/fileUploadSlice';
import type { UploadedProduct, FileUploadResponse, FileDetailsResponse } from '@/types/fileUpload';

function* uploadFileSaga(action: PayloadAction<UploadedProduct[]>) {
  try {
    const response: FileUploadResponse = yield call(uploadProductsFile, action.payload);
    yield put(uploadFileSuccess(response));
  } catch (error) {
    yield put(uploadFileFailure(error instanceof Error ? error.message : 'Failed to upload file'));
  }
}

function* getFileDetailsSaga(action: PayloadAction<string>) {
  try {
    const response: FileDetailsResponse = yield call(getFileDetails, action.payload);
    yield put(getFileDetailsSuccess(response));
  } catch (error) {
    yield put(getFileDetailsFailure(error instanceof Error ? error.message : 'Failed to fetch file details'));
  }
}

export function* fileUploadSaga() {
  yield takeLatest(uploadFileRequest.type, uploadFileSaga);
  yield takeLatest(getFileDetailsRequest.type, getFileDetailsSaga);
}